import { useEffect, useState } from "react";
import { DateTime } from "luxon";
import { useNavigate } from "react-router-dom";
import { useReport } from "../../context/ReportContext";

export default function Reports() {
  const { selectedType, setSelectedType, selectedPeriod, setSelectedPeriod } =
    useReport();
  const [availablePeriods, setAvailablePeriods] = useState([]);
  const navigate = useNavigate();

  const reportTypes = [
    {
      label: "Relatório de Fechamento - Sintético",
      value: "fechamento-sintetico",
    },
    {
      label: "Relatório de Fechamento - Analítico",
      value: "fechamento-analitico",
    },
    {
      label: "Relatório de Fechamento - Dep. Pessoal",
      value: "fechamento-dep-pessoal",
    },
    { label: "Relatório de Cancelamento", value: "cancelamento" },
    { label: "Relatório de Escalas", value: "escalas" },
  ];

  useEffect(() => {
    const generatePastMonths = () => {
      const now = DateTime.local().setZone("America/Sao_Paulo");
      const cutoffDate =
        DateTime.fromISO("2025-02-28").setZone("America/Sao_Paulo");
      const months = [];

      for (let i = 0; i < 12; i++) {
        const month = now.minus({ months: i });

        if (month < cutoffDate) break;

        const formattedMonth = month.toFormat("MM-yyyy"); // Format as "03-2025" (for API)

        months.push(formattedMonth);
      }

      setAvailablePeriods(months);
    };

    generatePastMonths();
  }, []);

  useEffect(() => {
    if (availablePeriods.length > 0 && !selectedPeriod) {
      setSelectedPeriod(availablePeriods[0]);
    }
  }, [availablePeriods, selectedPeriod, setSelectedPeriod]);

  const handleGenerateReport = () => {
    if (!selectedType || !selectedPeriod) {
      alert("Por favor, selecione um tipo de relatório e um período.");
      return;
    }

    navigate(`/admin/reports/${selectedType}?period=${selectedPeriod}`);
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-3">Emitir um Relatório</h2>
      <p>Escolha o Tipo e o Período do Relatório que deseja emitir.</p>

      <div className="d-flex align-items-start gap-5 mt-4 justify-content-center align-items-end">
        {/* Report Type Selection */}
        <div className="d-flex flex-column">
          <label className="fw-bold mb-2">Tipo</label>
          <select
            className="form-select"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <option value="" disabled>
              Selecione o tipo de relatório
            </option>
            {reportTypes.map(({ label, value }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>

        {/* Period Selection */}
        <div className="d-flex flex-column">
          <label className="fw-bold mb-2">Período</label>
          <select
            className="form-select"
            value={selectedPeriod}
            onChange={(e) => setSelectedPeriod(e.target.value)}
          >
            <option value="" disabled>
              Selecione o período
            </option>
            {availablePeriods.map((period) => (
              <option key={period} value={period}>
                {period}
              </option>
            ))}
          </select>
        </div>

        {/* Emit Report Button */}
        <div className="d-flex align-items-end">
          <button className="btn btn-primary" onClick={handleGenerateReport}>
            Emitir Relatório
          </button>
        </div>
      </div>
    </div>
  );
}
